module.exports = __webpack_public_path__ + "static/media/Golos_Text_DemiBold.5ad93e32.ttf";